import React from 'react';
import PropTypes from 'prop-types';
import { BodyText } from '@paypalcorp/pp-react';
import { appendCdnHostName } from '../../../../utility/geoUtils';

const ValuePropCard = ({ heading, body, imgSrc }) => {
  return (
    <div className="value-prop-card">
      <img className="value-prop-image" src={appendCdnHostName(imgSrc)} />
      <div>
        <BodyText strong className="value-prop-heading">
          {heading}
        </BodyText>
        <BodyText className="button-container-body">{body}</BodyText>
      </div>
    </div>
  );
};

ValuePropCard.propTypes = {
  heading: PropTypes.string,
  body: PropTypes.string,
  imgSrc: PropTypes.string,
};

export default ValuePropCard;
